import React from 'react';
import PropTypes from 'prop-types';
import css from './TextHeader.css'

function TextHeader(props) {
  return (
    <div className={css['text-header-container']} id={props.id}>
      <h2 className={css['h2']}>{props.upperText}</h2>
      <h1 className={css['h1']}>{props.lowerText}</h1>
    </div>
  );
}

TextHeader.propTypes = {
  id: PropTypes.string,
  upperText: PropTypes.string,
  lowerText: PropTypes.string
};

export default TextHeader;
